import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ScaleIndicatorScreen } from "../../screen/ScaleIndicatorListScreen";
import { useNavigate, useParams } from "react-router-dom";
import Send from "../../core/communication"
import { setData } from "../../core/redux/app/Actions";

const loadData = async (esmId, dispatch) => {
  const response = await Send.get(`/scale-indicator/scale/${esmId}`);

  const list =
  response.map((item) => ({
      id: item?.id,
      title: item?.title,
      category: item?.category
    })) || []


  dispatch(setData({ esmIndicators: list }))
}

const ScaleIndicatorListContainer = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const esmIndicators = useSelector(state => state?.app?.esmIndicators) || [];
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [values, setValues] = useState();

  useEffect(() => {
    if (params?.esmId && !modalIsOpen) {
      loadData(params?.esmId, dispatch)
    }
  }, [params, modalIsOpen])

  useEffect(() => {
    if (!modalIsOpen) {
      setIsUpdate(false)
    }
  }, [modalIsOpen])

  const onChangeValues = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const goToDetails = (id, isUpdate = false) => {
    if(isUpdate) {
      navigate(`/esm/indicator/${params?.esmId}/${id}`);
    } else {
      navigate(`/esm/indicator/new/${params?.esmId}`);
    }
  }

  return <ScaleIndicatorScreen
    {...{
      isUpdate,
      esmIndicators,
      modalIsOpen,
      setModalIsOpen,
      onChangeValues,
      values,
      goToDetails,
    }}
  />
}

export default ScaleIndicatorListContainer